import { EntityDescriptor } from '../business-logic';
import { vouchersSchema } from '../schemas/vouchers';

/* @deprecated not used — voucher flux (actions/effects/hook) removed; collection kept to avoid RxDB migration */
export const vouchersEntity: EntityDescriptor = {
	vouchers: {
		schema: vouchersSchema,
		migrationStrategies: {
			1: function (oldDoc: any) {
				return oldDoc;
			},
		},
	},
};
